import api from '@/helpers/api';

/**
 * Menu Service
 * Base path: /master/access/menu
 * ID format: UUID string (field `menu_id`)
 *
 * Kontrak response backend: { code, message, data }
 */

const BASE = '/master/access/menu';

export const menuService = {
  /**
   * GET /master/access/menu
   * Response.data: { active, inactive, menu: [{menu_id, title, sequence, status, children_count}] }
   */
  list(params = {}) {
    return api.get(BASE, { params });
  },

  /**
   * GET /master/access/menu/detail/{menu_id}
   * Response.data: { menu_id, title, url, status, parent_id, children: [...] }
   */
  detail(menuId) {
    return api.get(`${BASE}/detail/${menuId}`);
  },

  /**
   * GET /master/access/menu/edit/{menu_id}
   * Ambil data untuk form edit (termasuk route & url).
   */
  edit(menuId) {
    return api.get(`${BASE}/edit/${menuId}`);
  },

  /**
   * POST /master/access/menu/store
   * Body: { title, status, parent_id, url, route }
   */
  store(payload) {
    return api.post(`${BASE}/store`, payload);
  },

  /** PUT /master/access/menu/update/{menu_id} */
  update(menuId, payload) {
    return api.put(`${BASE}/update/${menuId}`, payload);
  },

  /** DELETE /master/access/menu/delete/{menu_id} */
  remove(menuId) {
    return api.delete(`${BASE}/delete/${menuId}`);
  },

  /**
   * GET /master/access/menu/sequence?parent_id={id}
   * Response.data: [{menu_id, title, sequence, parent_id}]
   */
  getSequence(parentId = '') {
    return api.get(`${BASE}/sequence`, {
      params: { parent_id: parentId ?? '' },
    });
  },

  /**
   * PUT /master/access/menu/update-sequence
   * Body: { menu_id: [uuid, uuid, ...] }
   */
  updateSequence(menuIds) {
    return api.put(`${BASE}/update-sequence`, { menu_id: menuIds });
  },

  /**
   * GET /me/menu
   * Menu untuk user yang sedang login (sudah di-filter berdasarkan role).
   * Endpoint ini BERBEDA dari /master/access/menu — yang ini dipakai oleh
   * sidebar/navbar runtime, sedangkan /master/access/menu dipakai halaman
   * master data Hak Akses untuk CRUD.
   *
   * Response.data: tree lengkap, tiap node punya {menu_id, title, url,
   * route, icon, status, parent_id, sequence, children: [...]}.
   */
  myMenu() {
    return api.get('/me/menu');
  },
};

export default menuService;